/* =============================================
   Active Ingredients Carousel JavaScript
   Mobile popup carousel + Desktop popup + Mobile carousel navigation
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {
  // ===========================================
  // MOBILE POPUP CAROUSEL
  // ===========================================
  const aipopCarousel = document.querySelector('.aipop-carousel');
  const cardCounter = document.querySelector('.aipop-card-counter');
  
  let aipopStartX = 0;
  let aipopCurrentIndex = 0;
  
  // Arrow Buttons
  const prevButton = document.querySelector('.aipop-prev-button');
  const nextButton = document.querySelector('.aipop-next-button');
  const totalCards = document.querySelectorAll('.aipop-card').length;
  
  // Left Arrow - Go to Previous Card
  prevButton.addEventListener('click', () => {
    if (aipopCurrentIndex > 0) {
      aipopCurrentIndex--;
      updateAipopCarousel();
    }
  });
  
  // Right Arrow - Go to Next Card
  nextButton.addEventListener('click', () => {
    if (aipopCurrentIndex < totalCards - 1) {
      aipopCurrentIndex++;
      updateAipopCarousel();
    }
  });
  
  function updateArrowVisibility() {
    // Always display both arrows
    prevButton.style.display = 'flex';
    nextButton.style.display = 'flex';
  }
  
  // Update Arrows and Carousel Position
  function updateAipopCarousel() {
    aipopCarousel.style.transform = `translateX(-${aipopCurrentIndex * 340}px)`;
    cardCounter.textContent = `${aipopCurrentIndex + 1} OF ${totalCards}`;
    updateArrowVisibility();
    updateActiveCard(); // Update active card scaling
  }
  
  function updateActiveCard() {
    const cards = document.querySelectorAll('.aipop-card');
    cards.forEach((card, index) => {
      if (index === aipopCurrentIndex) {
        card.classList.add('aipop-card-active');
      } else {
        card.classList.remove('aipop-card-active');
      }
    });
  }
  
  // Initialize Arrows
  updateArrowVisibility();
  
  aipopCarousel.addEventListener('touchstart', (e) => {
    aipopStartX = e.touches[0].clientX;
  });
  
  aipopCarousel.addEventListener('touchend', (e) => {
    const aipopEndX = e.changedTouches[0].clientX;
    const aipopDeltaX = aipopStartX - aipopEndX;
  
    if (aipopDeltaX > 50 && aipopCurrentIndex < 2) {
      aipopCurrentIndex++;
    } else if (aipopDeltaX < -50 && aipopCurrentIndex > 0) {
      aipopCurrentIndex--;
    }
    updateAipopCarousel();
  });

  // ===========================================
  // MOBILE POPUP OPEN/CLOSE FUNCTIONALITY
  // ===========================================
  const closeButtons = document.querySelectorAll('.aipop-close-button');
  const readMoreButtons = document.querySelectorAll('.ain-ingredient-popup-button');
  const overlay = document.querySelector('.aipop-overlay');
  const popupContainer = document.querySelector('.aipop-carousel-container');
  const carousel = document.querySelector('.aipop-carousel');
  const cards = document.querySelectorAll('.aipop-card');
  
  // Close popup functionality
  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      overlay.style.display = 'none';
      popupContainer.style.display = 'none';
      document.body.classList.remove('no-scroll');
    });
  });

  // Event listeners for "Read More" buttons
  readMoreButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      aipopCurrentIndex = index; // Open popup at the correct card
      updateAipopCarousel(); // Update carousel position
      overlay.style.display = 'block';
      popupContainer.style.display = 'block';
      document.body.classList.add('no-scroll'); // Disable scrolling
    });
  });

  // Close popup when overlay is clicked
  overlay.addEventListener('click', () => {
    overlay.style.display = 'none';
    popupContainer.style.display = 'none';
    document.body.classList.remove('no-scroll'); // Re-enable scrolling
  });

  // Swipe functionality for touch devices
  let startX = 0;

  carousel.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });

  carousel.addEventListener('touchend', (e) => {
    const endX = e.changedTouches[0].clientX;
    const deltaX = startX - endX;

    if (deltaX > 50 && aipopCurrentIndex < totalCards - 1) {
      aipopCurrentIndex++;
    } else if (deltaX < -50 && aipopCurrentIndex > 0) {
      aipopCurrentIndex--;
    }
    updateAipopCarousel();
  });

  // Initialize the active card for popup
  updateAipopCarousel();

  // ===========================================
  // DESKTOP POPUP CAROUSEL
  // ===========================================
  const closeButtonsDesktop = document.querySelectorAll('.aipop-close-button-desktop');
  const overlayDesktop = document.querySelector('.aipop-overlay-desktop');
  const popupContainerDesktop = document.querySelector('.aipop-carousel-container-desktop');
  const carouselDesktop = document.querySelector('.aipop-carousel-desktop');
  const cardsDesktop = document.querySelectorAll('.aipop-card-desktop');
  const prevButtonDesktop = document.querySelector('.aipop-prev-button-desktop');
  const nextButtonDesktop = document.querySelector('.aipop-next-button-desktop');
  const cardCounterDesktop = document.querySelector('.aipop-card-counter-desktop');
  const readMoreButtonsDesktop = document.querySelectorAll('.p-herbs-read-more-01');

  let aipopCurrentIndexDesktop = 0;
  const totalCardsDesktop = cardsDesktop.length;

  function updateAipopCarouselDesktop() {
    carouselDesktop.style.transform = `translateX(-${aipopCurrentIndexDesktop * 620}px)`;
    cardCounterDesktop.textContent = `${aipopCurrentIndexDesktop + 1} OF ${totalCardsDesktop}`;

    cardsDesktop.forEach((card, index) => {
      if (index === aipopCurrentIndexDesktop) {
        card.classList.add('aipop-card-active-desktop');
      } else {
        card.classList.remove('aipop-card-active-desktop');
      }
    });
  }

  closeButtonsDesktop.forEach(button => {
    button.addEventListener('click', () => {
      overlayDesktop.style.display = 'none';
      popupContainerDesktop.style.display = 'none';
      document.body.classList.remove('no-scroll');
    });
  });

  readMoreButtonsDesktop.forEach((button, index) => {
    button.addEventListener('click', () => {
      aipopCurrentIndexDesktop = index;
      updateAipopCarouselDesktop();
      overlayDesktop.style.display = 'block';
      popupContainerDesktop.style.display = 'block';
      document.body.classList.add('no-scroll');
    });
  });

  prevButtonDesktop.addEventListener('click', () => {
    if (aipopCurrentIndexDesktop > 0) {
      aipopCurrentIndexDesktop--;
      updateAipopCarouselDesktop();
    }
  });

  nextButtonDesktop.addEventListener('click', () => {
    if (aipopCurrentIndexDesktop < totalCardsDesktop - 1) {
      aipopCurrentIndexDesktop++;
      updateAipopCarouselDesktop();
    }
  });

  updateAipopCarouselDesktop();

  // ===========================================
  // MOBILE CAROUSEL NAVIGATION
  // ===========================================
  const mobileCarousel = document.querySelector('.ain-ingredients-carousel');
  const slides = Array.from(mobileCarousel.querySelectorAll('.ain-ingredient-block'));
  const prevMobile = document.querySelector('.ain-carousel-prev-button');
  const nextMobile = document.querySelector('.ain-carousel-next-button');
  let currentIndex = 0;

  const offsetPx = 420; /* 400px card width + 20px gap */

  function updatePositions() {
    slides.forEach((slide, i) => {
      const diff = i - currentIndex;
      const scale = (diff === 0) ? 1 : 1;
      const xOffset = diff * offsetPx;
      slide.style.transform = `translate(-50%, -50%) translateX(${xOffset}px) scale(${scale})`;
      slide.style.zIndex = (diff === 0) ? 10 : 5;
      slide.style.opacity = (Math.abs(diff) > 1) ? 0 : 1;
    });
  }

  updatePositions();

  // Tap/Click event to navigate by clicking on the side blocks
  slides.forEach((slide, i) => {
    slide.addEventListener('click', () => {
      currentIndex = i;
      updatePositions();
      updateNavButtons();
    });
  });

  // Swipe functionality
  let startXMobile = 0;
  let isTouching = false;

  mobileCarousel.addEventListener('touchstart', (e) => {
    startXMobile = e.touches[0].clientX;
    isTouching = true;
  });

  mobileCarousel.addEventListener('touchend', (e) => {
    if (!isTouching) return;
    const endX = e.changedTouches[0].clientX;
    const diffX = endX - startXMobile;
    if (diffX < -50 && currentIndex < slides.length - 1) {
      currentIndex++;
    } else if (diffX > 50 && currentIndex > 0) {
      currentIndex--;
    }
    updatePositions();
    updateNavButtons();
    isTouching = false;
  });

  // For desktop: mouse drag support (optional)
  let isDown = false;
  let startDragX = 0;

  mobileCarousel.addEventListener('mousedown', (e) => {
    e.preventDefault();
    startDragX = e.clientX;
    isDown = true;
  });

  document.addEventListener('mouseup', (e) => {
    if (!isDown) return;
    const diffX = e.clientX - startDragX;
    if (diffX < -50 && currentIndex < slides.length - 1) {
      currentIndex++;
    } else if (diffX > 50 && currentIndex > 0) {
      currentIndex--;
    }
    updatePositions();
    updateNavButtons();
    isDown = false;
  });

  // Navigation Buttons Functionality
  prevMobile.addEventListener('click', () => {
    if (currentIndex > 0) {
      currentIndex--;
      updatePositions();
      updateNavButtons();
    }
  });

  nextMobile.addEventListener('click', () => {
    if (currentIndex < slides.length - 1) {
      currentIndex++;
      updatePositions();
      updateNavButtons();
    }
  });

  // Disable buttons when at the ends
  function updateNavButtons() {
    if (currentIndex === 0) {
      prevMobile.style.opacity = 0.5;
      prevMobile.style.cursor = 'not-allowed';
    } else {
      prevMobile.style.opacity = 1;
      prevMobile.style.cursor = 'pointer';
    }

    if (currentIndex === slides.length - 1) {
      nextMobile.style.opacity = 0.5;
      nextMobile.style.cursor = 'not-allowed';
    } else {
      nextMobile.style.opacity = 1;
      nextMobile.style.cursor = 'pointer';
    }
  }

  // Initial call to set button states
  updateNavButtons();
});
